import Joyride, { ACTIONS, EVENTS } from 'react-joyride';
import React, { useEffect, useState } from 'react';
import {
  floatElementAboveTutorial,
  unFloatElementAboveTutorial,
  TUTORIAL_Z_INDEX,
} from 'utils/float';

export const TemplateBuilderTutorial = ({ onClose }) => {
  // Consts
  const isCX = window.location.protocol === 'chrome-extension:';
  // States
  const [tourKey, setTourKey] = useState(new Date());
  const [stepIndex, setStepIndex] = useState(0);
  const [steps, setSteps] = useState([]);

  const getTutorialSteps = () => {
    if (isCX) {
      return [
        {
          target: 'body',
          title: 'New Feature!',
          content: `Introducing the "Template Builder" for next-level note generation. Before We go further, let's give AI a masterclass with your notes using template builder to generate instructions for better note creation.`,
          placement: 'center',
        },
        {
          target: '#nav-TemplateBuilder',
          content:
            'Click here to kickstart your journey with the Template Builder!',
          placement: 'bottom', // Adjust the placement if needed
          disableBeacon: true, // Ensure the tooltip shows immediately
          disableScrolling: true,
          disableOverlayClose: true,
          hideCloseButton: true,
          hideBackButton: true,
        },
      ];
    }
    return [];
  };

  useEffect(() => {
    openSideNav();
    const initialSteps = getTutorialSteps();
    setSteps(filterStepsBasedOnDOM(initialSteps));
  }, []);

  const filterStepsBasedOnDOM = (steps) => {
    return steps.filter((step) => document.querySelector(step.target));
  };

  // New function to ensure the side navigation is open
  const openSideNav = () => {
    return new Promise((resolve) => {
      const navBarToggleButton = document.querySelector('#navbar-menu-button');
      if (navBarToggleButton) {
        // Open the nav bar
        // navBarToggleButton.click();
      }
      resolve();
    });
  };

  // Modified handleJoyrideCallback function to open side nav before highlighting
  const handleJoyrideCallback = async (data) => {
    const { action, index, type, step, lifecycle, status } = data;

    if (type === EVENTS.STEP_AFTER || type === EVENTS.TARGET_NOT_FOUND) {
      setStepIndex(index + (action === ACTIONS.PREV ? -1 : 1));
    }
    console.log('(step.target', step.target);
    // await openSideNav();
    if (step.target === '#nav-TemplateBuilder') {
      const targetElement = document.querySelector(step.target);
      if (targetElement) {
        targetElement.classList.add('highlight');
      } else {
        console.error(`Element with selector ${step.target} not found.`);
      }
    }

    if (status === 'finished' || action === 'skip') {
      localStorage.setItem('template-builder-tutorial', 'done');
      if (onClose) onClose();
    }
  };

  const customStyles = {
    buttonNext: {
      backgroundColor: '#6bd888',
    },
    buttonBack: {
      backgroundColor: '#212529',
      color: 'white',
      borderRadius: '4px',
    },
  };
  return (
    <div className="Tutorial">
      <Joyride
        key={tourKey}
        steps={steps}
        stepIndex={stepIndex}
        callback={handleJoyrideCallback}
        continuous={true}
        showProgress={true}
        showSkipButton={true}
        hideCloseButton={true}
        disableCloseOnEsc={true}
        disableScrolling={true}
        disableOverlayClose={true}
        styles={{
          options: {
            zIndex: TUTORIAL_Z_INDEX,
          },
          ...customStyles,
        }}
        locale={{
          last: 'End',
        }}
      />
    </div>
  );
};
